<template>
    <transition name="fade">
        <div v-show="toastStore.state.show"
             class="toast-overlay">
            <div class="custom-toast"
                 :style="{top: toastTop() + 'px',
                        width: toastStore.state.width + 'px',
                        fontSize: FontSizes.small1}">{{ toastStore.state.message }}</div>
        </div>
    </transition>
</template>

<script lang="ts">
import {defineComponent} from "vue";
import {toastStore} from "@/stores/toast-store";
import {FontSizes} from "@/utils/font-sizes";

export default defineComponent({
    name: "Toast",
    setup() {

        const toastTop = (): number => {
            return toastStore.state.show ? 40 : -40
        }

        return {
            toastStore,
            toastTop,
            FontSizes,
        }
    }
})
</script>

<style scoped lang="scss">

.fade-enter-active,
.fade-leave-active {
    /* 表示されている際のCSSはこのブロックに記述 */
    transition: opacity .5s .5s;
}

.fade-enter-from,
.fade-leave-to {
    /* 非表示の際のCSSはこのブロックに記述 */
    opacity: 0;
}

.toast-overlay {
    position: fixed;
    pointer-events: none;
    left: 0;
    top: 0;
    width: 100vw;
    height: 100vh;
    z-index: 3000;
    //background-color: red;

    .custom-toast {
        position: absolute;
        right: 20px;
        //width: 200px;
        height: 40px;
        border-radius: 10px;
        background-color: rgba(100, 100, 100, 0.7);
        color: white;
        line-height: 40px;
        text-align: center;
        transition: top 0.5s;
    }
}
</style>